module.exports = __webpack_public_path__ + "img/service-point-delivered.e2f45766.svg";